export const REBATE_TYPES = {
  percent: "percent",
  productFixed: "fixed_product",
  cartFixed: "fixed_cart",
};
